module.exports = __webpack_public_path__ + "img/index21.1bf91232.png";